import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiFormLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingBottom: theme.spacing(1),
      color: theme.palette.text.primary,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
      // Ensure label doesn't change color on focus
      "&.Mui-focused": {
        color: "inherit"
      },
      // Override label behavior to keep labels above inputs - Select needs this to be consistent with TextField label behavior
      "&.MuiInputLabel-formControl, &.MuiInputLabel-shrink": {
        transform: "none",
        position: "relative"
      },
      // Styles for TextField form item description
      "& .cds-textFieldDescription": {
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing(0.5),
        textWrap: "wrap"
      },
      "& .cds-textFieldCounter": {
        color: theme.palette.text.secondary
      },
      ".cds-textFieldLabelWithCounter": {
        margin: 0,
        display: "flex",
        justifyContent: "space-between",
        textWrap: "wrap"
      }
    })
  }
};
export {
  MuiFormLabel
};
//# sourceMappingURL=MuiFormLabel.js.map
